import { KeySquare } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const KeySquareIcon = createLucideIcon(KeySquare);
